import { memo } from 'react'
import React from 'react'

import { Box, Paper } from '@material-ui/core'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'

import useCustom from './hooks'

const IdmMenu = () => {
  const { tabMenus, currentTab, handleChangeTab } = useCustom()

  return (
    <Box px={4}>
      <Paper>
        <Tabs
          value={currentTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChangeTab}
          aria-label="disabled tabs example"
        >
          {tabMenus.map((menu) => (
            <Tab
              value={menu.id}
              key={menu.id}
              label={
                <Box display="flex" alignItems="center">
                  <img
                    src={menu.icon}
                    alt={menu.title}
                    style={{ width: 24, height: 24, marginRight: 8 }}
                  />
                  {menu.title}
                </Box>
              }
            />
          ))}
        </Tabs>
      </Paper>
    </Box>
  )
}

export default memo(IdmMenu)
